import React from "react";
import { useHistory } from 'react-router-dom';

// redux
import { useSelector, useDispatch } from "react-redux";
import { selectSelectedTimeline } from "_redux/slices/timeline/timeline-areas";
import { setShowTimelineSidebar, setTimeLineDate, selectTimelineDate } from "_redux/slices/timeline/timeline-control";
import { selectUsedTheme } from '_redux/slices/timeline/theme';
import { selectFirebaseInfo } from "_redux/slices/main-screen/user";

// constants
import { TIMELINE_V2_AIRPORTS } from "_utils/constants";

// tremor
import { Flex } from "@tremor/react";

// styling
import { Colors, Spacing } from "_styles";

// custom components
import { DateTime } from "_atoms";

// icons 
import { IoSettingsOutline } from "react-icons/io5";
import { CiFileOn } from "react-icons/ci";
import { IoChevronBackCircleSharp } from "react-icons/io5";
import { FcQuestions } from "react-icons/fc";
import { FiLogOut } from "react-icons/fi";

// bootstrap
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

// functions
import { getDate } from "_utils/functions";

const TimelineTitles = (props) => {

  // nav
  const history = useHistory();

  //#region redux
  const dispatch = useDispatch();

  const selectedTimeline = useSelector(selectSelectedTimeline);
  const timelineDate = useSelector(selectTimelineDate);                    // select timeline Date
  const usedTheme = useSelector(selectUsedTheme);
  const dbUser = useSelector(selectFirebaseInfo);
  //#endregion

  const showEmployeeSettings = () => {
    history.push("/employee-settings");
  }

  const isEmployee = props?.isEmployee

  return (
    <Row style={{
      display: 'flex',
      justifyContent: 'space-between',
      padding: 0, flex: 1, margin: 0,
      backgroundColor: !isEmployee ? usedTheme.BACKGROUND_COLOR : 'transparent',
      borderBottomStyle: 'solid',
      borderBottomWidth: 2.5, borderBottomColor: isEmployee || props?.isReportPage ? Colors.PRM_LIGHT_BLUE : 'transparent'
    }}>

      {/* left side */}
      <Col>
        <Row style={{}}>

          {/* go back to timeline icon (or logout for REPORTS_ONLY users) */}
          <Col xs={10} style={{ display: "flex", alignItems: "center", paddingInlineStart: "10px", }}>
            {dbUser?.role === "REPORTS_ONLY" ? (
              <FiLogOut
                size={30}
                onClick={() => history.push("/logout")}
                color={Colors.PRM_LIGHT_BLUE}
                cursor="pointer"
                style={{}}
                data-tippy-content="Log Out"
              />
            ) : (
              <IoChevronBackCircleSharp
                size={35}
                onClick={() => {
                  if (isEmployee || props?.isReportPage) {
                    history.push(TIMELINE_V2_AIRPORTS.includes(dbUser.details.authority) ? "/timeline-view-v2" : "/timeline-view");
                  } else {
                    history.push(TIMELINE_V2_AIRPORTS.includes(dbUser.details.authority) ? "/timeline-v2" : "/timeline");
                  }
                }}
                color={Colors.PRM_LIGHT_BLUE} cursor="pointer"
                style={{}}
                data-tippy-content="Go Back"
              />
            )}

            {/* settings / report buttons*/}
            {!isEmployee && !props?.isReportPage && (
              <>
                <IoSettingsOutline
                  size={35}
                  // onClick={() => history.push("/timeline-control-panel")}
                  onClick={() => dispatch(setShowTimelineSidebar(true))}
                  color={Colors.PRM_LIGHT_BLUE} cursor="pointer"
                  style={{ borderRadius: "20px", padding: 5 }}
                  data-tippy-content="Settings"
                />

                {/* go to timeline analytics*/}
                <CiFileOn
                  size={35}
                  onClick={() => history.push("/timeline-reports", { timeline: true })}
                  color={Colors.PRM_LIGHT_BLUE}
                  cursor="pointer"
                  style={{ borderRadius: "20px", padding: 5 }}
                  data-tippy-content="Reports"
                />


                {selectedTimeline && <div>
                  <p style={{ fontSize: 14, color: Colors.PRM_LIGHT_BLUE, marginBottom: -4, fontWeight: "bold", cursor: "pointer" }} onClick={showEmployeeSettings}>
                    {selectedTimeline?.title ? `Area: ${selectedTimeline?.title}` : ""}
                  </p>
                </div>
                }
              </>
            )}
          </Col>

          {/* auto check in location 
          {!isEmployee && (
          <div>
            <AutoCheckInLocation showSubtitle={false} upperCase={true} />
          </div>
          )}
          */}

          {/* date picker */}
          <Col style={{ marginBottom: Spacing.SCALE_4, marginTop: Spacing.SCALE_4 }}>
            {!props?.isReportPage && <DateTime date={getDate(timelineDate)} setDate={(date) => dispatch(setTimeLineDate(date))} timeline={true} />}
          </Col>

        </Row>
      </Col>

    </Row>
  );
};

export default TimelineTitles;
